import { Color, Icon, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Pressable, StyleSheet, View, ViewProps } from 'react-native'
import { Zone } from 'zens-store'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    borderWidth: 1,
    borderColor: Color.calmGrey,
    borderRadius: Radius.S,
    padding: Spacing.S,
    marginVertical: Spacing.XS,
    flexDirection: 'row',
  },
  col: {
    flex: 1,
  },
  icon: {
    marginRight: Spacing.M,
  },
  hover: {
    borderWidth: 2,
    borderColor: Color.premiumBlack,
    marginHorizontal: -1,
    marginVertical: Spacing.XS - 1,
  },
  pressed: {
    backgroundColor: Color.sleepingGrey,
  },
})

interface Props extends ViewProps {
  companyId: number
  zones?: Zone[]
  testOnly_pressed?: boolean
}

const WorkspaceZones = (props: Props) => {
  const { companyId, style, zones, testOnly_pressed, ...otherProps } = props
  const { t } = useTranslation()

  const renderZone = (zone: Zone) => (state: { pressed: boolean; hovered?: boolean }) => {
    const { pressed, hovered } = state
    const { id, name, numberOfWorkspaces } = zone

    const style = [styles.row, hovered && styles.hover, pressed && styles.pressed]
    return (
      <View style={style} key={id}>
        <Icon name="location" style={styles.icon} />
        <View style={styles.col}>
          <Text level={5}>{name}</Text>
        </View>
        <View style={styles.col}>
          <Text>{t('{{count}} workspaces', { count: numberOfWorkspaces })}</Text>
        </View>
      </View>
    )
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {zones?.length ? (
        zones?.map((zone) => (
          <Link href={`/companies/${companyId}/workspaces/zones/${zone.id}`} asChild key={zone.id}>
            <Pressable testID="WorkspaceZones.Pressable" testOnly_pressed={testOnly_pressed}>
              {renderZone(zone)}
            </Pressable>
          </Link>
        ))
      ) : (
        <Text>
          <Trans>This workspace is not yet part of a workspace zone.</Trans>
        </Text>
      )}
    </View>
  )
}

export default WorkspaceZones
